import { mergeStyles, numberToPrettyString } from '@cian/utils';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferHelper } from '../../../presenter';
import { IOffer } from '../../../types/offer';
import { IUser } from '../../../types/user';

import * as styles from './index.css';

export interface IPriceProps {
  mortgageBanner?: React.ReactNode | undefined;
  priceClassName?: string;
  currentSubdomain: string;
  excludedUtilitiesTermsRegions: number[];
  isDealRentCianAgency?: boolean;
}

export interface IPriceContext {
  offer: IOffer;
  offerHelper: IOfferHelper;
  user: IUser;
}

function getCurrency(currency: string) {
  switch (currency) {
    case 'eur':
      return '\u20ac';
    case 'usd':
      return '\u0024';
    case 'percent':
      return '%';
    default:
      return '\u20bd';
  }
}

export class Price extends React.Component<IPriceProps, {}> {
  public context: IPriceContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    user: PropTypes.object,
  };

  public render() {
    const offer = this.context.offerHelper;

    if (
      this.context.offer.offerType === 'commercial' ||
      offer.commercial.isCommercialLand()
    ) {
      return null;
    }

    const terms = this.context.offer.dealType === 'rent'
      ? this.getRentPriceTerms(this.props.excludedUtilitiesTermsRegions)
      : this.getSalePriceTerms();

    return (
      <div>
        {terms.map((term: React.ReactNode, index) => {
          if (term) {
            return (
              <div
                key={index}
                {...mergeStyles([
                  index === 0 ? styles['header'] : styles['term'],
                  index === 0 && this.props.priceClassName,
                ])}
              >
                {term}
              </div>
            );
          }

          return null;
        })}
      </div>
    );
  }

  protected renderAgentBonus = () => {
    const agentBonus = this.context.offer.bargainTerms.agentBonus;

    if (this.context.user.isAuthenticated && Boolean(this.context.user.isAgent) && agentBonus) {
      const bonusCurrency = agentBonus.paymentType === 'fixed'
        ? getCurrency(agentBonus.currency || '')
        : getCurrency(agentBonus.paymentType);

      return `Бонус агенту ${numberToPrettyString(agentBonus.value)} ${bonusCurrency}`;
    }

    return null;
  }

  protected getSalePriceTerms = (): React.ReactNode[] => {
    const offer = this.context.offerHelper;
    const isSuburban = offer.isSuburban();

    const priceData  = [
      offer.simplifiedCard.getSalePrice(),
    ];

    if (!isSuburban) {
      priceData.push(offer.simplifiedCard.getSalePricePerMeter() as string);
    }

    priceData.push(this.renderAgentBonus());

    return priceData;
  }

  protected getRentPriceTerms = (excludedUtilitiesTermsRegions: number[]): React.ReactNode[] => {
    const { presenters, simplifiedCard } = this.context.offerHelper;
    const { isDealRentCianAgency } = this.props;

    let clientFee = presenters.getClientFee();
    if (isDealRentCianAgency) {
      clientFee += ' в пользу Циан';
    }

    return [
      simplifiedCard.getRentPrice(excludedUtilitiesTermsRegions),
      presenters.getMoreRentPrice(),
      this.context.user.isAuthenticated && Boolean(this.context.user.isAgent)
        ? presenters.getFee()
        : clientFee,
      presenters.getDeposit(),
      this.renderAgentBonus(),
    ];
  }
}
